export default {
    methods: {
        setPassFlowTo(route) {
            return this.$route?.params?.passFlowTo ?? route;
        },
    },
};
